import React from 'react';
import NavigationLink from './NavigationLink';
import { useLanguage } from '../contexts/LanguageContext';

const NavigationLinks = ({
    className = "main-menu__link btn btn-anim",
    wrapperClassName = "main-menu__item",
    onLinkClick
}) => {
    const { t } = useLanguage();

    const navigationItems = [
        {
            to: "/",
            children: t('navigation.home')
        },
        {
            to: "/sell",
            children: t('navigation.sell')
        },
        {
            to: "/renovation",
            children: t('navigation.reforms')
        },
        {
            to: "/community",
            children: t('navigation.community')
        },
        {
            to: "/search",
            children: t('navigation.search')
        },
        {
            to: "/about",
            children: t('navigation.about')
        },
        {
            to: "/financing",
            children: t('navigation.financing')
        },
        {
            href: "https://wa.me/34610683948",
            children: t('navigation.contact'),
            target: "_blank",
            rel: "noopener noreferrer"
        }
    ];

    return (
        <>
            {navigationItems.map((item, index) => (
                <NavigationLink
                    key={index}
                    to={item.to}
                    href={item.href}
                    target={item.target}
                    rel={item.rel}
                    className={className}
                    wrapperClassName={wrapperClassName}
                    onLinkClick={onLinkClick}
                >
                    {item.children}
                </NavigationLink>
            ))}
        </>
    );
};

export default NavigationLinks;
